import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

interface Props {
  onClose: () => void;
}

const CloseButton = ({ onClose }: Props) => (
  <StylishNewButton className="button--secondary border-0" onClick={onClose}>
    Cancel
  </StylishNewButton>
);

export default CloseButton;
